import Navbar from './components/Navbar';
import Hero from './components/Hero';
import Services from './components/Services';
import Realisations from './components/Realisations';
import WhyMe from './components/WhyMe';
import Process from './components/Process';
import CtaSection from './components/CtaSection';
import Testimonials from './components/Testimonials';
import Contact from './components/Contact';
import Footer from './components/Footer';
import CookieBanner from './components/CookieBanner';

export default function Home() {
  return (
    <div className="min-h-screen text-white relative">
      {/* Fixed global background */}
      <div className="fixed inset-0 -z-50">
        <img
          src="https://readdy.ai/api/search-image?query=Abstract%20luxury%20dark%20digital%20background%20dominated%20by%20deep%20black%20and%20rich%20dusty%20rose%20pink%20tones%2C%20soft%20blush%20pink%20glowing%20light%20orbs%20and%20delicate%20pink%20neon%20geometric%20curves%20floating%20in%20dark%20space%2C%20elegant%20web%20design%20wireframes%20and%20typography%20compositions%20in%20subtle%20rose%20pink%20hues%2C%20smooth%20pink%20gradient%20light%20rays%20emanating%20from%20corners%2C%20no%20yellow%2C%20no%20orange%2C%20no%20warm%20gold%20tones%2C%20only%20cool%20rose%20pink%20and%20black%2C%20sophisticated%20feminine%20digital%20art%20studio%20aesthetic%2C%20no%20people%2C%20no%20faces%2C%20cinematic%20depth%20with%20soft%20pink%20bokeh%2C%208K%20ultra%20detailed%20professional%20digital%20art&width=1920&height=1080&seq=manovahero5rose&orientation=landscape"
          alt=""
          className="w-full h-full object-cover object-[65%_center] md:object-center"
        />
        <div className="absolute inset-0 bg-black/50" />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-transparent to-black/60" />
      </div>

      <Navbar />
      <Hero />
      <Services />
      <Realisations />
      <WhyMe />
      <Process />
      <CtaSection />
      <Testimonials />
      <Contact />
      <Footer />
      <CookieBanner />
    </div>
  );
}